export default __webpack_public_path__ + "static/BasierCircle-SemiBoldItalic-2437b651a8275f93118ea158457dfb7d.woff";